module.exports = __webpack_public_path__ + "img/20210211_094858.94f002cc.jpg";